import React, { useCallback, useEffect, useState } from 'react';
import { NoData } from 'src/@vymo/ui/blocks';
import { Widget } from 'src/@vymo/ui/molecules';
import { getCurrentUser } from 'src/models/lmsConfig/queries';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { getLeaderboards, getPerformanceCards } from '../selector';
import { fetchDashboardRankings } from '../thunk';
import LeaderboardWidget from './leaderboardWidget';
import { getLeaderboardPayload } from './queries';
import styles from '../index.module.scss';

function Dashboard() {
  const dispatch = useAppDispatch();
  const [activeLeaderboard, setActiveLeaderboard] = useState<string>('');
  const user = getCurrentUser();
  const leaderboards = useAppSelector(getLeaderboards);
  const performanceCards = useAppSelector(getPerformanceCards);

  useEffect(() => {
    if (activeLeaderboard) {
      dispatch(
        fetchDashboardRankings({
          payload: getLeaderboardPayload(
            { limit: 3, skip: 0 },
            user.code,
            activeLeaderboard,
          ),
        }),
      );
    }
  }, [dispatch, activeLeaderboard, user.code]);

  useEffect(() => {
    setActiveLeaderboard(leaderboards?.[0]?.code);
  }, [leaderboards]);

  const getDashboardCard = useCallback(
    (card: any) => {
      switch (card?.code) {
        case 'leaderboard':
          return (
            <LeaderboardWidget
              activeLeaderboard={activeLeaderboard}
              setActiveLeaderboard={setActiveLeaderboard}
              leaderboards={leaderboards}
            />
          );
        default:
          return (
            <Widget
              title={card?.title}
              content={<NoData message="Coming Soon..." />}
            />
          );
      }
    },
    [activeLeaderboard, leaderboards],
  );

  return (
    <div className={styles.dashboardWrapper}>
      {performanceCards?.map((card) => getDashboardCard(card))}
    </div>
  );
}

export default Dashboard;
